import { render, staticRenderFns } from "./ReportBulletPointTable.vue?vue&type=template&id=66a02636&"
import script from "./ReportBulletPointTable.vue?vue&type=script&lang=ts&"
export * from "./ReportBulletPointTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66a02636')) {
      api.createRecord('66a02636', component.options)
    } else {
      api.reload('66a02636', component.options)
    }
    module.hot.accept("./ReportBulletPointTable.vue?vue&type=template&id=66a02636&", function () {
      api.rerender('66a02636', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/report/bulletpoints/ReportBulletPointTable.vue"
export default component.exports